// --- React
import React from "react";
// --- External UI Libraries
import Button from "@dtci/spellbook/Button";
// --- Components
import { ValidationError } from "tap/components/ValidationError";

const VALIDATION_SUMMARY_MESSAGE =
  "Fix validation errors before saving.";

/**
 * Footer actions for rate card create/edit drawers.
 * @param {Object} props
 * @param {boolean} props.hasValidationErrors - Whether the form has validation errors
 * @param {Function} props.onClose - Handler for cancel/close
 * @param {Function} props.onSave - Handler for save
 */
export function RateCardDrawerFooter({
  hasValidationErrors,
  onClose,
  onSave,
}) {
  return (
    <div className="rate-card-drawer-footer">
      <Button
        iconType="fa-solid fa-xmark"
        labelText="close"
        styleType="link"
        onClick={onClose}
      >
        Cancel
      </Button>
      <div className="rate-card-drawer-footer-save">
        <Button
          iconType="fa-solid fa-floppy-disk"
          labelText="save"
          styleType="link"
          onClick={onSave}
        >
          Save
        </Button>
        {hasValidationErrors && (
          <ValidationError
            error={VALIDATION_SUMMARY_MESSAGE}
            className="rate-card-drawer-footer-validation-message"
          />
        )}
      </div>
    </div>
  );
}
